import { Injectable } from '@angular/core';

declare const window:any;
@Injectable({
  providedIn: 'root'
})
export class DeviceService {

  constructor() { }

  isMobile(){
    return window? (( window.innerWidth <= 800 ) && ( window.innerHeight <= 750 )):false;
  }
}
